import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=4b82cb8c&scoped=true&"
import script from "./reset.vue?vue&type=script&lang=js&"
export * from "./reset.vue?vue&type=script&lang=js&"
import style0 from "./reset.vue?vue&type=style&index=0&id=4b82cb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b82cb8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b82cb8c')) {
      api.createRecord('4b82cb8c', component.options)
    } else {
      api.reload('4b82cb8c', component.options)
    }
    module.hot.accept("./reset.vue?vue&type=template&id=4b82cb8c&scoped=true&", function () {
      api.rerender('4b82cb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Password/reset.vue"
export default component.exports